import { SET_FOOTER_DATA } from './actionTypes';

const initialState = {
  navs: undefined,
  platform: undefined
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FOOTER_DATA:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
